import {Injectable} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {ConfirmDialogComponent} from './confirm-dialog.component';

@Injectable()
export class DialogsService {

  constructor(public dialog: MatDialog) {

  }

  public openConfirmDialog(config = null): MatDialogRef<ConfirmDialogComponent> {
    config = config || Object.assign({
          width: '350px'
        },
        config);
    return this.dialog.open(ConfirmDialogComponent, config);
  }

}
